import React from 'react';
import pic from '/static/start1.png';
import Button from '@material-ui/core/Button';
import useAuth from '/hooks/useAuth';
import { makeStyles } from '@material-ui/core/styles';
import { useAppSelector } from 'redux/storeConfig';
import { useNavigate } from 'react-router-dom';

const useStyles = makeStyles((t) => ({
  imageContainer: {
    position: 'relative',
    width: '100%',
    backgroundImage: `url(${pic})`,
    height: '530px',
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: '50% 50%',
    [t.breakpoints.down('sm')]: {
      height: '480px',
    },
    [t.breakpoints.down('xs')]: {
      height: '430px',
    },
  },
  buttonContainer: {
    margin: '0 auto',
    width: '297px',
    marginTop: '456px',
    [t.breakpoints.down('sm')]: {
      marginTop: '383px',
    },
    [t.breakpoints.down('xs')]: {
      width: '248px',
      marginTop: '295px',
    },
  },
  buttonRegister: {
    width: '97px',
    marginRight: '51px',
    [t.breakpoints.down('xs')]: {
      marginRight: '27px',
    },
  },
  buttonLogin: {
    width: '97px',
    marginLeft: '51px',
    [t.breakpoints.down('xs')]: {
      marginLeft: '27px',
    },
  },
}));

const Jumbotron = () => {
  const classes = useStyles();
  const navigate = useNavigate();
  const projectId = useAppSelector((state) => state.projectInfo.projectId);
  const token = useAuth();

  return (
    <div className={classes.imageContainer}>
      <div className={classes.buttonContainer}>
        {token === null ? (
          <>
            <Button
              color="secondary"
              variant="contained"
              className={classes.buttonRegister}
              onClick={() => navigate(`/${projectId}/createaccount`)}
            >
              Register
            </Button>
            <Button
              color="secondary"
              variant="contained"
              className={classes.buttonLogin}
              onClick={() => navigate(`/${projectId}/login`)}
            >
              Login
            </Button>
          </>
        ) : null}
      </div>
    </div>
  );
};

export default Jumbotron;
